const Correlations = () => {
  return (
    <div>Correlations</div>
  )
}

export default Correlations